import styled from "styled-components";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";
import { CashCategory, TripCostDebt } from "../../../types/common.types";

interface TripCostDebtsProps {
    day?: Date
    endDay?: Date
}

export default function TripCostDebts({ day, endDay }: TripCostDebtsProps) {
    const { setIsLoading } = useGlobal()
    const { setCreateCashMovementPrefill, setIsCreateCashMovementModalOpen } = useAdmin()
    const [debts, setDebts] = useState<TripCostDebt[]>([])
    const [defaultCategoryId, setDefaultCategoryId] = useState('')

    useEffect(() => {
        async function load() {
            setIsLoading(true)
            try {
                const [debtsRes, categoriesRes] = await Promise.all([
                    AdminService.listTripCostDebts(false, day, endDay),
                    AdminService.listCashCategories('egreso'),
                ])
                setDebts(debtsRes.data)
                const operadores = (categoriesRes.data as CashCategory[]).find(c => c.name === 'Operadores / Choferguías')
                if (operadores) setDefaultCategoryId(operadores.id)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        load()
    }, [setIsLoading, day, endDay])

    function registerPago(debt: TripCostDebt) {
        setCreateCashMovementPrefill({
            trip_cost_debt_id: debt.id,
            amount: debt.amount,
            counterpart_name: debt.name,
            movement_type: 'egreso',
            category_id: defaultCategoryId || undefined,
        })
        setIsCreateCashMovementModalOpen(true)
    }

    return (
        <Main>
            <h3>Deudas de trip por pagar (chofer/guía)</h3>
            {debts.length === 0 && <p className="empty">No hay deudas de trip pendientes</p>}
            {debts.map(debt => (
                <div className="row" key={debt.id}>
                    <div className="info">
                        <span className="name">{debt.name}</span>
                        <span className="trip">{debt.trip && format(new Date(debt.trip.trip_date), 'dd/MM/yyyy')} — {debt.trip?.tour_id}</span>
                    </div>
                    <span className="amount">${debt.amount.toLocaleString('es-CL')}</span>
                    <button type="button" onClick={() => registerPago(debt)}>Registrar pago</button>
                </div>
            ))}
        </Main>
    )
}

const Main = styled.div`
margin: 20px 0;
h3 { font-size: 16px; margin-bottom: 10px; }
.empty {
    color: ${props => props.theme.gray};
    font-size: 14px;
}
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    border-radius: 8px;
    background: ${props => props.theme.whiteBackground};
    margin-bottom: 8px;
    flex-wrap: wrap;
    .info {
        display: flex;
        flex-direction: column;
        .name { font-weight: 600; }
        .trip { font-size: 12px; color: ${props => props.theme.gray}; }
    }
    .amount { font-weight: 700; }
    button {
        padding: 8px 12px;
        border-radius: 6px;
        border: 2px solid ${props => props.theme.blue};
        background: transparent;
        color: ${props => props.theme.blue};
        cursor: pointer;
    }
}
`
